module.exports = __webpack_public_path__ + "static/flame_tongue-afac5bc56be05be7946af89e17458eba.jpeg";